import request from '@/utils/request';

export function ApiGetSysDictList(data){
  return request({
    method: 'post',
    url: '/fenydata-java-console/api/0/v1/sysDict/getSysDictList',
    data: data,
  });
}
